// extracted by mini-css-extract-plugin
module.exports = {"bonusCash":"_e1878f2","bonusCashAmount":"_96cfa2c","bonusCashExpiry":"_3507452","iconChevron":"_ded3ed8","iconChevronOpen":"_ccd0a32"};